export default "__VITE_ASSET__DYiFBkyw__"